import { Icon } from "../Icon.jsx";
import { XAI_SCHOOL_LINKS } from "../../data/consultantCourse.js";

const organizationPoints = [
  "Percorso adattato ai casi del team",
  "Materiali e verifiche condivise",
  "Attestati e avanzamento tracciabili",
];

export function OrganizationsSection() {
  return (
    <section className="organizations-section page-section" id="organizzazioni" aria-labelledby="organizations-title">
      <div>
        <span className="section-kicker">Per studi, reti e organizzazioni</span>
        <h2 id="organizations-title">Lo stesso metodo, condiviso dal team.</h2>
        <p>
          Costruiamo un percorso comune per usare l’AI con criteri, linguaggio e controlli coerenti
          con il vostro lavoro.
        </p>
      </div>
      <div className="organizations-section__details">
        {organizationPoints.map((point) => (
          <div key={point}><Icon name="checkCircle" size={20} /><span>{point}</span></div>
        ))}
        <a className="button button--outline" href={XAI_SCHOOL_LINKS.organizations}>
          Scopri le soluzioni <Icon name="arrow" size={18} />
        </a>
      </div>
    </section>
  );
}
